import dayjs from 'dayjs'
import { createSignal, For, onMount } from 'solid-js'
import { Portal } from 'solid-js/web'
import { SearchOutline } from '@/icons'
import { res2json } from '@/utils'

const [rows, setRows] = createSignal([])

export default function DailyBets() {
  const query = new URLSearchParams(document.location.search)
  const [agentOptions, setAgentOptions] = createSignal([])
  const [agent, setAgent] = createSignal('')
  const [loading, setLoading] = createSignal(true)

  const [infoDay, setInfoDay] = createSignal('')

  const isAgent = !!query.get('agent')

  onMount(() => {
    Promise.allSettled([
      fetch(`/api/agents/options`).then(res2json).then(r => {
        setAgentOptions(r.data ?? [])
        setAgent(query.get('agent') ?? '')
      }),
      fetch(`/api/statistics/daily-bets?${query.toString()}`).then(res2json).then(r => { setRows(r.data ?? []) }),
    ]).finally(() => { setLoading(false) })
  })

  function openByDayDialog(day) {
    setInfoDay(day)
    window.byDay.showModal()
  }

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>每日投注统计</li>
          </ul>
        </div>
        <div class="flex items-center justify-between">
          <h2 class="text-xl">每日投注统计</h2>
        </div>
        <form class="join">
          <select name="agent" value={agent()} onChange={e => setAgent(e.target.value)} class="select select-bordered join-item">
            <option value="">全部代理</option>
            {agentOptions().map(e => (<option value={e.username}>{e.username}{e.nickname && <span>({e.nickname})</span>}</option>))}
          </select>
          <button type="submit" class="btn join-item"><span class="w-5"><SearchOutline /></span></button>
        </form>
        <div class="overflow-x-auto">
          <table class="table whitespace-nowrap">
            <thead>
              <tr class="bg-base-200">
                <th class="px-2 lg:px-3">日期</th>
                {!isAgent && <th class="px-2 lg:px-3">投注代理数量</th>}
                <th class="px-2 lg:px-3">投注玩家数量</th>
                <th class="px-2 lg:px-3">玩家投注指令数量</th>
                <th class="px-2 lg:px-3">投注机器人数量</th>
                <th class="px-2 lg:px-3">机器人投指令数量</th>
              </tr>
            </thead>
            <tbody>
              <For each={rows()}>
                {(row) => (
                  <tr class="hover:bg-base-200">
                    <td class="px-2 lg:px-3">{row.day}</td>
                    {!isAgent && (
                      row.number_of_agents > 0 ? <td onClick={() => !isAgent && openByDayDialog(row.day)} class="px-2 lg:px-3 cursor-pointer">{row.number_of_agents}</td> : <td>0</td>
                    )}
                    {row.number_of_players > 0 ? <td onClick={() => !isAgent && openByDayDialog(row.day)} class="px-2 lg:px-3 cursor-pointer">{row.number_of_players}</td> : <td>0</td>}
                    {row.number_of_player_bet_slips > 0 ? <td onClick={() => !isAgent && openByDayDialog(row.day)} class="px-2 lg:px-3 cursor-pointer">{row.number_of_player_bet_slips}</td> : <td>0</td>}
                    <td class="px-2 lg:px-3">{row.number_of_robots}</td>
                    <td class="px-2 lg:px-3">{row.number_of_robot_bet_slips}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </div>
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}

        <ByDayDialog day={infoDay} />
      </Portal>
    </>
  )
}

function ByDayDialog({ day }) {
  const [rows, setRows] = createSignal([])
  const [loading, setLoading] = createSignal(true)

  onMount(() => {
    new MutationObserver((e) => {
      if (e[0].target.open) {
        setLoading(true)
        fetch(`/api/statistics/daily-bets/${day()}`).then(res2json).then(r => setRows(r.data)).finally(() => setLoading(false))
      }
    }).observe(window.byDay, { attributes: true })
  })

  function cancel() {
    window.byDay.close()
  }

  return (
    <dialog id="byDay" class="modal">
      <div class="modal-box flex flex-col gap-4">
        <form method="dialog">
          <button type="button" onClick={() => cancel()} class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" disabled={loading()}>✕</button>
        </form>
        <h3 class="text-lg">{day()} 投注统计</h3>
        {loading() ? <div class="loading loading-dots"></div> : (
          <div class="overflow-x-auto">
            <table class="table whitespace-nowrap">
              <thead>
                <tr class="bg-base-200">
                  <th>代理账号</th>
                  <th>投注玩家数量</th>
                  <th>玩家投注指令数量</th>
                </tr>
              </thead>
              <tbody>
                <For each={rows()}>
                  {(row) => (
                    <tr class="hover:bg-base-200">
                      <td>{row.agent}</td>
                      <td>{row.number_of_players}</td>
                      <td>{row.number_of_player_bet_slips}</td>
                    </tr>
                  )}
                </For>
              </tbody>
            </table>
          </div>
        )}
        <div class="modal-action">
          <button type="button" onClick={() => cancel()} class="btn px-8" disabled={loading()}>关闭</button>
        </div>
      </div>
    </dialog>
  )
}
